/**
 * Fires onerror if the src is invalid
 */
export function verifyImgSrc(src, callback) {
  const img = new Image();
  img.onload = () => callback(true);
  img.onerror = () => callback(false);
  img.src = src;
}

export function verifyHref(href, cb) {
  fetch(href).then(response => {
    if (response.status >= 200 && response.status <= 399) {
      cb(true);
    } else {
      cb(false);
    }
  });
}

export const get = (obj, path, defValue) => {
  // If path is not defined or it has false value
  if (!path) return undefined;
  // Check if path is string or array. Regex : ensure that we do not have '.' and brackets.
  // Regex explained: https://regexr.com/58j0k
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  // Find value if exist return otherwise return undefined value;
  return pathArray.reduce((prevObj, key) => prevObj && prevObj[key], obj) || defValue;
};
